import mascotQuotes from '../Data/mascotQuotes.json';

export function getRandomMascotQuote() {
  return mascotQuotes[Math.floor(Math.random() * mascotQuotes.length)];
}
